import React,{useEffect,useRef,useState} from 'react';

// Heading input saves once on blur, instead of adding an Undo step for each key.
export default function StorySectionHeading({section,maxIndex,initialFocus=false,dragging=false,dropSide=null,onDragStart,onDragOver,onDrop,onDragEnd,onRename,onMove,onRemove}){
  const [draft,setDraft]=useState(section.title);
  const input=useRef(null);
  useEffect(()=>{setDraft(section.title);},[section.title]);
  useEffect(()=>{if(initialFocus){input.current?.focus();input.current?.select();}},[initialFocus]);
  const save=()=>{const next=draft.trim();if(next&&next!==section.title)onRename(section.id,next);else setDraft(section.title);};
  return <div className={`story-section-divider${dragging?' is-dragging':''}${dropSide?' drop-'+dropSide:''}`}
    data-heading-id={section.id} aria-label={'Assembly section: '+section.title}
    onDragOver={event=>onDragOver?.(event,section.id)}
    onDrop={event=>onDrop?.(event,section.id)}>
    <span className="story-section-rule" aria-hidden="true"/>
    <div className="story-section-line">
      <button type="button" className="story-section-grip" draggable
        aria-label={'Drag section heading '+section.title+' to reorder'}
        title="Drag heading above or below another passage or heading"
        onDragStart={event=>onDragStart?.(event,section.id)}
        onDragEnd={onDragEnd}>
        <svg viewBox="0 0 12 16" width="12" height="16" aria-hidden="true" focusable="false">
          {[3,8,13].flatMap(y=>[3,9].map(x=><circle key={`${x}-${y}`} cx={x} cy={y} r="1.5" fill="currentColor"/>))}
        </svg>
      </button>
      <span className="story-section-symbol" aria-hidden="true">§</span>
      <input ref={input} aria-label="Section heading" title={section.editorialReason ? `AI chapter rationale: ${section.editorialReason}` : "Rename section heading"} value={draft} maxLength={100}
        placeholder="Name this section…" onChange={event=>setDraft(event.target.value)}
        onBlur={save} onKeyDown={event=>{
          if(event.key==='Enter'){event.preventDefault();event.currentTarget.blur();}
          if(event.key==='Escape'){setDraft(section.title);event.currentTarget.blur();}
        }}/>
      <div className="story-section-buttons">
        <button type="button" disabled={section.beforeIndex<=0} onClick={()=>onMove(section.id,-1)} aria-label="Move section heading earlier" title="Move heading up one passage">↑</button>
        <button type="button" disabled={section.beforeIndex>=maxIndex} onClick={()=>onMove(section.id,1)} aria-label="Move section heading later" title="Move heading down one passage">↓</button>
        <button type="button" className="story-section-delete" onClick={()=>onRemove(section.id)} aria-label={'Delete section heading '+section.title} title="Remove this heading only">×</button>
      </div>
    </div>
  </div>;
}
